<template>
    <div class="flex space-x-3">
        <DiagonalCutButton @click="$emit('previous')" variant="secondary" cut-position="right-top">
            <svg class="size-3.5" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.41436 7.00008L8.70726 1.70718L7.29304 0.292969L0.585938 7.00008L7.29304 13.7072L8.70726 12.293L3.41436 7.00008Z"
                    fill="currentColor"
                />
            </svg>
            <span class="mt-0.5">{{ $t('general.previous') }}</span>
        </DiagonalCutButton>
        <DiagonalCutButton
            @click="$emit('next')"
            :disabled="!canProceed"
            variant="primary"
            cut-position="left-top"
        >
            <span class="mt-0.5">{{ $t('general.next') }}</span>
            <svg class="size-3.5" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.58563 6.99992L0.292742 12.2928L1.70696 13.707L8.41406 6.99992L1.70695 0.292818L0.292741 1.70703L5.58563 6.99992Z"
                    fill="currentColor"
                />
            </svg>
        </DiagonalCutButton>
    </div>
</template>

<script>
import DiagonalCutButton from '../DiagonalCutButton.vue'

export default {
    components: {
        DiagonalCutButton,
    },
    props: {
        canProceed: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['next', 'previous'],
}
</script>
